import { useEffect } from 'react';

import { useEditorContext } from '@/features/canvas/contexts/editor-context';
import { InitiativeBudgetData } from '@/features/canvas/types/budget-type';

export const useInitiativeBudgets = () => {
  const { allBudgets, setInitiativeBudgets, setIsLoadingBudgets, isPublicView } =
    useEditorContext();

  // Update budget map whenever allBudgets changes
  useEffect(() => {
    // In public view, set loading to false immediately since data comes from snapshot
    if (isPublicView) {
      setIsLoadingBudgets(false);
    }

    if (!allBudgets || allBudgets.length === 0) {
      setIsLoadingBudgets(false);
      return;
    }

    const budgetMap = new Map<number, InitiativeBudgetData>();
    allBudgets.forEach(budget => {
      budgetMap.set(budget.initiative_id, budget);
    });

    setInitiativeBudgets(budgetMap);
    setIsLoadingBudgets(false);
  }, [allBudgets, setInitiativeBudgets, setIsLoadingBudgets, isPublicView]);

  return {
    isLoading: false,
    budgetData: allBudgets || [],
  };
};
